import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import { useSelector } from "react-redux";
import { useDispatch, } from "react-redux";
import {useHistory} from 'react-router-dom'
import { updateSocietiesSelected } from '../../Store/Ducks/duckSocieties';
import { Grid } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { getCountries,updateCountriesSelected } from "../../Store/Ducks/duckCountries";
import {snackAction} from '../../components/CustomSnakbar.jsx';
import { useSnackbar } from "notistack";
import {ROUTES} from '../../constants'
const useStyles = makeStyles((theme) => ({
  containerGrid: {
    backgroundColor: "white",
    padding: "20px",
    marginTop:"25px",
    width:"80%",
    marginLeft:"10%",
    // border:"solid 1px black",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.91)",  
  },
}));

export const CountryList = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { societies } = props;
  const countries = useSelector(store => store.countries.data);

  const sortItems = (array) =>
  array.sort((a, b) => a.description.toUpperCase().localeCompare(b.description.toUpperCase()));

  const [societiesList, setSocietiesList] = React.useState(sortItems(societies))
  const [selectIds, setselectIds] = React.useState()
  
  const handleChangeSelected = (ids) => {
    let newList = selectIds;
    newList = newList.map((item)=>{
      if(ids.includes(item.id))
        item.selected=true;
      else
        item.selected=false;
        return item; 
    });

      dispatch(updateCountriesSelected(newList))
  }

  const handleClickUpdateSocieties = () => {
    let newList = societiesList.map((item)=>{
      if(selectIds.filter(x=>x.selected).map(x=>x.id).includes(item.countryId))
        item.selected=true;
      else
        item.selected=false;
        return item;
    });
    dispatch(updateSocietiesSelected(newList))
    enqueueSnackbar(`Datos actualizados`, { variant: "success", action: snackAction, autoHideDuration: 2000 });
    history.push(ROUTES.HOME)
  }

  React.useEffect(() => {
    if (countries.length===0){
      dispatch(getCountries())
    }
  }, [countries.length, dispatch])

React.useEffect(() => {
    if (countries.length>0)
        setselectIds(countries)
}, [countries, selectIds])

  return (
    <>
      {
       <Grid container spacing={2}  className={classes.containerGrid}>
          <Grid item xs={10}>
            <Autocomplete
              multiple
              id="society"
              name="society"
              value={countries.filter(x=>x.selected).map(x=>x.id)}
              options={countries.map(x => x.id)}
              getOptionLabel={option => {
                let country =countries.find((x) => x.id === option)
                return `(${country.name}) - ${country.longName}`
              }
              }
              onChange={(event, value) =>{
               handleChangeSelected(value)}}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Seleccionar Pais Sociedad TEIC a Facturar"
                  fullWidth
                  value={countries.filter(x=>x.selected).map(x=>x.id)}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={2}>
            <Button onClick={handleClickUpdateSocieties} variant="contained" style={{ marginLeft: "15px",marginTop:"10px" }}>
              NEXT
          </Button>
          </Grid>
        </Grid> 
      }
    </>
  );
}
